import React from "react";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo/payeasy1.png";
import { Button, Result } from "antd";

class Page404 extends React.Component {
  componentDidUpdate(prevProps, prevState) {}
  render() {
    return (
      <div className="theme-cyan">
        <div>
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="card">
                  
                  <div className="body">
                    <div className="top text-center">
                      <img src={Logo} alt="Lucid" width={150} />
                    </div>
                    
                    <div className="margin-top-30">
                      <Result
                        status="404"
                        title="404 Page Not Found"
                        subTitle="Sorry, the page you visited does not exist."
                        extra={
                          <Button
                            type="primary"
                            onClick={() => {
                              this.props.history.push("dashboard");
                            }}
                          >
                            Back Home
                          </Button>
                        }
                      />
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Page404.propTypes = {};

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(Page404);
